import { CouponMapper } from './coupon';

const couponMapper = new CouponMapper();

export { couponMapper };

export * from './filters.mapper';
